import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Grid, 
  Stack
} from '@mui/material';
import { TransportationOption } from '@/types';
import TransportationOptionCard from '@/components/transportation/TransportationOptionCard';
import { useI18n } from '@/hooks/useI18n';

interface TransportationOptionsPageProps {
  transportationOptions: TransportationOption[];
  onAddTransportationOption: (option: Omit<TransportationOption, 'id'>) => void;
  onUpdateTransportationOption: (option: TransportationOption) => void;
  onDeleteTransportationOption: (optionId: string) => void;
}

const TransportationOptionsPage: React.FC<TransportationOptionsPageProps> = ({ 
  transportationOptions, 
  onAddTransportationOption, 
  onUpdateTransportationOption, 
  onDeleteTransportationOption 
}) => {
  const { t } = useI18n();
  
  return (
    <Stack spacing={3}>
      <Grid container spacing={2}>
        {transportationOptions.map((option) => (
          <Grid size={{ xs: 12, lg: 6, xl: 4 }} key={option.id}>
            <TransportationOptionCard 
              transportationOption={option}
              onUpdateTransportationOption={onUpdateTransportationOption}
              onDeleteTransportationOption={onDeleteTransportationOption}
            />
          </Grid>
        ))}
      </Grid>

      {transportationOptions.length === 0 && (
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              🚗 {t('transportation.list.noOptionsYet')}
            </Typography>
            <Typography variant="body2" color="text.disabled" sx={{ mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
              ➕ {t('transportation.list.addOptionsHelp')}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Stack>
  );
};

export default TransportationOptionsPage;